import React from 'react'
import PropTypes from 'prop-types'
import {Box} from '@salesforce/retail-react-app/app/components/shared/ui'
import {Swiper, SwiperSlide} from 'swiper/react'
import 'swiper/css'

import PDComponent from '../../pd-component'

export const PromoGridFourColumns = ({regions}) => {
    return (
        <Box
            sx={{
                '.swiper:not(.swiper-initialized) .swiper-wrapper': {
                    display: 'flex'
                },
                '.swiper-slide': {
                    width: {
                        base: 'calc(100vw - 40px)',
                        md: 'calc(25% - 7.5px)'
                    },
                    minWidth: {md: '472px', '3xl': 'auto'},
                    aspectRatio: {base: '364 / 386', md: '472 / 428'},
                    marginRight: {base: '20px', md: '10px'},

                    '&:last-child': {
                        marginRight: 0
                    }
                },
                '.swiper-backface-hidden .swiper-slide': {
                    transform: 'none'
                }
            }}
        >
            <Swiper slidesPerView={'auto'} spaceBetween="0">
                {regions?.map((region) =>
                    region?.components?.map((component, index) => (
                        <SwiperSlide key={`${region.id}-${index}`}>
                            <PDComponent component={component} variant="promoGridFourItems" />
                        </SwiperSlide>
                    ))
                )}
            </Swiper>
        </Box>
    )
}

PromoGridFourColumns.propTypes = {
    regions: PropTypes.arrayOf(
        PropTypes.shape({
            components: PropTypes.arrayOf(
                PropTypes.shape({
                    data: PropTypes.shape({
                        question: PropTypes.string,
                        answer: PropTypes.string
                    })
                })
            )
        })
    ).isRequired
}

export default PromoGridFourColumns
